import { render, staticRenderFns } from "./StockCostList.vue?vue&type=template&id=fb14221c&scoped=true&"
import script from "./StockCostList.vue?vue&type=script&lang=ts&"
export * from "./StockCostList.vue?vue&type=script&lang=ts&"
import style0 from "./StockCostList.vue?vue&type=style&index=0&id=fb14221c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb14221c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VSimpleTable})
